import React from 'react';

const InfoCircleIcon = () => {
  return (
    <svg
      className="c-InfoCircleIcon"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 20 20">
      <path
        d="M10 0.00012207C4.48 0.00012207 0 4.48012 0 10.0001C0 15.5201 4.48 20.0001 10 20.0001C15.52 20.0001 20 15.5201 20 10.0001C20 4.48012 15.52 0.00012207 10 0.00012207ZM10 11.0001C9.45 11.0001 9 10.5501 9 10.0001V6.00012C9 5.45012 9.45 5.00012 10 5.00012C10.55 5.00012 11 5.45012 11 6.00012V10.0001C11 10.5501 10.55 11.0001 10 11.0001ZM11 15.0001H9V13.0001H11V15.0001Z"
        fill="#D2A500"
      />
    </svg>
  );
};

export default InfoCircleIcon;
